import { render, staticRenderFns } from "./MySpace.vue?vue&type=template&id=2bd3f717&scoped=true"
import script from "./MySpace.vue?vue&type=script&lang=js"
export * from "./MySpace.vue?vue&type=script&lang=js"
import style0 from "./MySpace.vue?vue&type=style&index=0&id=2bd3f717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3f717",
  null
  
)

export default component.exports